import { clusters_type_item } from "./../../../contexts/clusters";
import { namespaces_type_item } from "./../../../contexts/namespaces";
import { workspaces_type_item } from "./../../../contexts/workspaces";
import { cluster_info_type } from "../../../contexts/cluster-info";
import { quota_type } from "../../../contexts/quota-management";
import {
  response_type,
  metric_values,
  post_processes_type,
  item,
  result_type,
  post_processes_args_default,
  role_type_2,
  post_processes_args_metric,
  item_workload,
  type_new,
  post_processes_args_db,
  left_menu_item,
  db_response,
} from "../interfaces";
import { role_type } from "../../../contexts/roles";

declare var level: string[];
declare var http_request_worker: Function;
declare const close: Function;

export function post_processes(): post_processes_type {
  return {
    user_info: ({ response, cluster_session, workspace_session }: post_processes_args_default) =>
      new Promise((resolve: (value?: unknown) => void) => {
        if (response.roles) {
          const { roles }: response_type = response,
            sort_and_map: Function = (roles_filtered: role_type[], item_key: string): clusters_type_item[] =>
              roles_filtered
                .sort((a: role_type, b: role_type): number => a.cluster?.toLocaleLowerCase().localeCompare(b.cluster?.toLocaleLowerCase() || ""))
                .map(
                  (role_each: role_type): clusters_type_item => {
                    return {
                      metadata: { name: ((role_each as unknown) as role_type_2)[item_key], key: item_key },
                      // status: { status: "Active" },
                    } as clusters_type_item;
                  }
                ),
            roles_filtered: role_type[] | undefined = roles.filter(
              (role_each: role_type, index: number): boolean =>
                roles.findIndex(({ cluster }: role_type) => cluster?.length && cluster === role_each.cluster) === index
            );
          response.clusters = sort_and_map(roles_filtered, "cluster");

          const filter_clusters = (level_required: number, item_key: string): clusters_type_item[] | undefined => {
              const filtered_clusters: clusters_type_item[] = sort_and_map(
                roles?.filter(({ roleName }: role_type): boolean => level.findIndex((level_each: string) => level_each === roleName) < level_required),
                item_key
              );
              return filtered_clusters.filter(
                (cluster_each: clusters_type_item, index: number): boolean =>
                  filtered_clusters?.findIndex(
                    ({ metadata }: clusters_type_item) => filtered_clusters?.length && metadata.name === cluster_each.metadata.name
                  ) === index
              );
            },
            cluster_selected_name: string = (roles?.find((role_each) => role_each.cluster === cluster_session) || (roles || [])[0])?.cluster,
            workspace_selected_name: string | undefined = (roles?.find((role_each) => role_each.workspace === workspace_session) || (roles || [])[0])
              ?.workspace;
          Object.assign(response, {
            clusters_for_clusters_page: filter_clusters(3, "cluster"),
            clusters_for_workspaces_page: filter_clusters(4, "cluster"),
            cluster_selected_name,
            workspace_selected_name,
          });
        }
        resolve(response);
      }),
    cluster_info: ({ response, old_data, index }: post_processes_args_default) =>
      new Promise((resolve) => {
        const cluster_info: cluster_info_type = (response as unknown) as cluster_info_type,
          cluster_status_arr: string[] = [
            "CPU",
            cluster_info.usedCPU,
            cluster_info.totalCPU,
            "Memory",
            cluster_info.usedMemory,
            cluster_info.totalMemory,
            "Rootfs",
            cluster_info.usedRootfs,
            cluster_info.totalRootfs,
            "Pod",
            cluster_info.usedPod,
            cluster_info.totalPod,
            "PVC Disk",
            cluster_info.usedDisk,
            cluster_info.totalDisk,
            "GPU",
            cluster_info.usedGPU,
            cluster_info.totalGPU,
          ],
          get_float: (num: number) => number = (num: number): number => parseFloat(num.toFixed(3));

        let name: string, used: number, total: number, used_str: string, total_str: string;
        response.display = ([] as unknown) as (string | number)[][];
        for (let i = 0; i < cluster_status_arr.length; i += 3) {
          name = cluster_status_arr[i];
          used_str = cluster_status_arr[i + 1];
          total_str = cluster_status_arr[i + 2];
          used = get_float(Number(used_str)) || 0;
          total = get_float(Number(total_str)) || 1;
          response.display = response.display.concat([name, total_str, used_str, used, total]);
        }
        const item = (old_data || [])[index];

        item && (item.metadata = Object.assign(item.metadata, response));
        resolve(old_data || response);
      }),
    workspace_info: function (): Promise<response_type> {
      return post_processes().cluster_info.apply(this, arguments);
    },
    namespace_info: function (): Promise<response_type> {
      return post_processes().cluster_info.apply(this, arguments);
    },
    node_info: ({ response, old_data, index }: post_processes_args_default) =>
      new Promise((resolve: (value?: unknown) => void) => {
        if (old_data) {
          const item = old_data[index],
            metadata = response.metadata;
          if (metadata) {
            const spec = response.spec;
            metadata.role = {
              role: key_to_title((Object.keys(metadata.labels).find((key: string) => key.includes("role")) || "").replace("node-role.kubernetes.io/", "")),
              taints: spec && spec.taints,
            };
            item.metadata = Object.assign(item.metadata, metadata);
          } else item.metadata = Object.assign(item.metadata, response);
        }
        resolve(old_data);
      }),
    workspaces: ({
      response,
      page,
      hostname,
      kind,
      no_info,
      role,
      datacenter_name,
      cluster_name,
      subscription_id,
      unit_provide,
    }: post_processes_args_default) =>
      new Promise((resolve: (value?: unknown) => void) => {
        kind === "workspaces" &&
          response.items &&
          !response.items[0]?.metadata &&
          (response.items = (response.items as any[]).map(({ id, name }) => {
            return ({ metadata: { name: id, labels: { name } } } as unknown) as item;
          }));
        const is_clusters: boolean = page === "clusters" || kind === "clusters";
        if ((kind === "nodes" || kind === "workspaces" || kind === "namespaces" || kind === "clusters") && response.items && !no_info) {
          let old: string;
          const workers: { worker: Worker; listener: EventListenerObject }[] = [],
            promises: Promise<response_type | undefined>[] = response.items.map(({ metadata }: item, index: number) => {
              return new Promise((resolve_2: (value?: response_type | PromiseLike<response_type> | undefined) => void) => {
                http_request_worker(
                  `/v1/datacenter/${datacenter_name}${!is_clusters ? `/cluster/${cluster_name}` : ""}/${kind.substr(0, kind.length - 1)}/${
                    metadata?.name
                  }/info${subscription_id ? `?subscriptionId=${subscription_id}` : ""}`,
                  role,
                  index,
                  hostname,
                  0,
                  datacenter_name,
                  cluster_name,
                  undefined,
                  undefined,
                  page === "workspaces" || kind === "workspaces" ? "workspace_info" : kind === "nodes" ? "node_info" : "namespace_info",
                  response.items,
                  undefined,
                  subscription_id
                )
                  .then(({ result }: result_type) => {
                    if ((kind === "workspaces" && role === "workspaceOwner") || (kind === "namespaces" && role === "namespaceDeveloper")) {
                      const info_arr: { [key: string]: () => void } = {
                        workspaces: () => {
                          onmessage = (e: any) => {
                            const { result, unit_provide } = JSON.parse(e.data);
                            if (result && ((result as unknown) as workspaces_type_item[]).length > 0) {
                              const { metadata }: workspaces_type_item =
                                ((result as unknown) as workspaces_type_item[] | undefined)?.reduce(
                                  (acc: workspaces_type_item, cur: workspaces_type_item): workspaces_type_item => {
                                    const {
                                      usedPod,
                                      usedService,
                                      usedSecret,
                                      usedConfigmap,
                                      usedCPU,
                                      usedMemory,
                                      totalNamespaces,
                                    } = acc.metadata as workspaces_type_item["metadata"];
                                    return Object.assign(acc, {
                                      metadata: {
                                        usedPod: (Number(usedPod) + Number(cur.metadata.usedPod) || 0).toString(),
                                        usedService: (Number(usedService) + Number(cur.metadata.usedService) || 0).toString(),
                                        usedSecret: (Number(usedSecret) + Number(cur.metadata.usedSecret) || 0).toString(),
                                        usedConfigmap: (Number(usedConfigmap) + Number(cur.metadata.usedConfigmap) || 0).toString(),
                                        usedCPU: (Number(usedCPU) + Number(cur.metadata.usedCPU) || 0).toString(),
                                        usedMemory: (Number(usedMemory) + Number(cur.metadata.usedMemory) || 0).toString(),
                                        totalNamespaces: (Number(totalNamespaces) + Number(cur.metadata.totalNamespaces) || 0).toString(),
                                      },
                                    });
                                  }
                                ) || ({ metadata: {} } as workspaces_type_item);

                              postMessage(
                                JSON.stringify([
                                  "namespaces",
                                  metadata?.totalNamespaces || "",
                                  "workspace-info/namespaces",
                                  "pod",
                                  metadata?.usedPod || "0",
                                  "",
                                  "service",
                                  metadata?.usedService || "N/A",
                                  "",
                                  "secret",
                                  metadata?.usedSecret || "N/A",
                                  "",
                                  "config_map",
                                  metadata?.usedConfigmap || "N/A",
                                  "",
                                  "cpu",
                                  `${Number(metadata?.usedCPU).toFixed(2) || 0} core`,
                                  "",
                                  "memory",
                                  metadata?.usedMemory ? `${change_unit(metadata?.usedMemory, unit_provide, false)} ${unit_provide}` : `0 ${unit_provide}`,
                                  "",
                                ])
                              );
                            } else postMessage("[]");

                            setTimeout(() => {
                              close();
                            }, 0);

                            function change_unit(mi?: string | number, unit?: string, back_to_Mi?: boolean): number {
                              //change unit from Mi to user selected
                              if (mi && mi === "*") mi = -1;
                              const units: (string | number)[] = ["Pi", 1 / 1024 / 1024 / 1024, "Ti", 1 / 1024 / 1024, "Gi", 1 / 1024, "Mi", 1, "Ki", 1024];
                              const unit_found: number = units.findIndex((xx) => xx === unit);
                              const transform: any = units[unit_found + 1];
                              return mi
                                ? back_to_Mi
                                  ? Number((Number(mi) / transform).toFixed(2))
                                  : mi === -1
                                  ? -1
                                  : Number((Number(mi) * transform).toFixed(2))
                                : 0;
                            }
                          };
                        },
                        namespaces: () => {
                          onmessage = (e: any) => {
                            const { result, unit_provide } = JSON.parse(e.data);
                            const { metadata }: namespaces_type_item =
                              ((result as unknown) as namespaces_type_item[] | undefined)?.reduce(
                                (acc: namespaces_type_item, cur: namespaces_type_item): namespaces_type_item => {
                                  const {
                                    usedPod,
                                    usedService,
                                    usedSecret,
                                    usedConfigmap,
                                    usedCPU,
                                    usedMemory,
                                    totalNamespaces,
                                  } = acc.metadata as namespaces_type_item["metadata"];
                                  return Object.assign(acc, {
                                    metadata: {
                                      usedPod: (Number(usedPod) + Number(cur.metadata.usedPod) || 0).toString(),
                                      usedService: (Number(usedService) + Number(cur.metadata.usedService) || 0).toString(),
                                      usedSecret: (Number(usedSecret) + Number(cur.metadata.usedSecret) || 0).toString(),
                                      usedConfigmap: (Number(usedConfigmap) + Number(cur.metadata.usedConfigmap) || 0).toString(),
                                      usedCPU: (Number(usedCPU) + Number(cur.metadata.usedCPU) || 0).toString(),
                                      usedMemory: (Number(usedMemory) + Number(cur.metadata.usedMemory) || 0).toString(),
                                      totalNamespaces: (Number(totalNamespaces) + Number(cur.metadata.totalNamespaces) || 0).toString(),
                                    },
                                  });
                                }
                              ) || ({ metadata: {} } as namespaces_type_item);

                            postMessage(
                              JSON.stringify([
                                "namespaces",
                                result ? ((result as unknown) as namespaces_type_item[]).length.toString() : "",
                                "workspace-info/namespaces",
                                "pod",
                                metadata?.usedPod || "0",
                                "",
                                "service",
                                metadata?.usedService || "N/A",
                                "",
                                "secret",
                                metadata?.usedSecret || "N/A",
                                "",
                                "config_map",
                                metadata?.usedConfigmap || "N/A",
                                "",
                                "cpu",
                                `${Number(metadata?.usedCPU).toFixed(2) || 0} core`,
                                "",
                                "memory",
                                metadata?.usedMemory ? `${change_unit(metadata?.usedMemory, unit_provide, false)} ${unit_provide}` : `0 ${unit_provide}`,
                                "",
                              ])
                            );

                            setTimeout(() => {
                              close();
                            }, 0);

                            function change_unit(mi?: string | number, unit?: string, back_to_Mi?: boolean): number {
                              //change unit from Mi to user selected
                              if (mi && mi === "*") mi = -1;
                              const units: (string | number)[] = ["Pi", 1 / 1024 / 1024 / 1024, "Ti", 1 / 1024 / 1024, "Gi", 1 / 1024, "Mi", 1, "Ki", 1024];
                              const unit_found: number = units.findIndex((xx) => xx === unit);
                              const transform: any = units[unit_found + 1];
                              return mi
                                ? back_to_Mi
                                  ? Number((Number(mi) / transform).toFixed(2))
                                  : mi === -1
                                  ? -1
                                  : Number((Number(mi) * transform).toFixed(2))
                                : 0;
                            }
                          };
                        },
                      };
                      const worker: Worker = new Worker(
                          URL.createObjectURL(new Blob([`(${info_arr[kind].toString()})()`], { type: "application/javascript" }))
                        ),
                        listener: EventListenerObject = (((e: any) => {
                          workers[index].worker.removeEventListener("message", workers[index].listener);
                          const items = JSON.parse(e.data);
                          if (old) {
                            const items_old = JSON.parse(old);
                            for (let i = 1; i < items.length; i += 3) {
                              if (Number(items[i]) > Number(items_old[i])) {
                                postMessage(JSON.stringify([{ kind: `${role}_info`, items }]));
                                break;
                              }
                            }
                          } else postMessage(JSON.stringify([{ kind: `${role}_info`, items }]));
                          // if (e.data !== old) postMessage(JSON.stringify([{ kind: `${role}_info`, items:  }]))
                          old = e.data;
                          response.items = (result as unknown) as item[];
                          postMessage(JSON.stringify([response]));
                          resolve_2();
                        }) as unknown) as EventListenerObject;
                      worker.postMessage(JSON.stringify({ result, unit_provide }));
                      worker.addEventListener("message", listener);
                      workers[index] = { worker, listener };
                    } else {
                      response.items = (result as unknown) as item[];
                      postMessage(JSON.stringify([response]));
                      resolve_2();
                    }
                  })
                  .finally(() => {
                    if (kind === "nodes")
                      http_request_worker(
                        `/v1/datacenter/${datacenter_name}${!is_clusters ? `/cluster/${cluster_name}` : ""}/node/${metadata && metadata.name}${
                          subscription_id ? `?subscriptionId=${subscription_id}` : ""
                        }`,
                        role,
                        index,
                        hostname,
                        0,
                        datacenter_name,
                        cluster_name,
                        undefined,
                        undefined,
                        "node_info",
                        response.items,
                        undefined,
                        subscription_id
                      )
                        .then(({ result }: result_type) => {
                          response.items = (result as unknown) as item[];
                          postMessage(JSON.stringify([response]));
                        })
                        .finally(() => {
                          resolve_2();
                        });
                  });
              });
            });
          Promise.all(promises).finally(() => {
            resolve(response);
          });
        } else {
          resolve(response);
        }
      }),
    namespaces: function (): Promise<response_type> {
      return post_processes().workspaces.apply(this, arguments);
    },
    clusters: function (): Promise<response_type> {
      return post_processes().workspaces.apply(this, arguments);
    },
    nodes: function (): Promise<response_type> {
      return post_processes().workspaces.apply(this, arguments);
    },
    workspace: function (): Promise<response_type> {
      return post_processes().workspaces.apply(this, arguments);
    },
    workspacequotas: ({ response }: post_processes_args_default) =>
      new Promise((resolve) => {
        const key_old: string[] = ["limits.cpu", "limits.memory", "limits.ephemeral-storage", "requests.storage", 'requests.nvidia.com/gpu', 'requests.cpu', 'requests.ephemeral-storage', 'requests.memory'],
          key_new: string[] = ["limitCPU", "limitMemory", "limitsRootfs", "limitsDisk", 'gpu', 'requestCPU', 'requestRootfs', 'requestMemory'];

        let quota_info: type_new;
        response.items &&
          ((response.items as unknown) as quota_type["items"]).forEach((quota) => {
            quota_info = quota.spec?.quotas as type_new;
            if (quota_info) {
              key_old.forEach((key: string, index: number) => {
                quota_info[key_new[index]] = (quota_info as type_new)[key];
                delete (quota_info as type_new)[key];
              });
              const { limitCPU, limitMemory, limitsRootfs, limitsDisk, pods, gpu } = quota_info;
              quota_info && (quota.metadata = Object.assign({ limitCPU, limitMemory, limitsRootfs, limitsDisk, pods, gpu }, quota.metadata));
            }
          });
        resolve(response);
      }),
    namespacequotas: ({ response }: post_processes_args_default) =>
      new Promise((resolve) => {
        const key_old: string[] = ["limits.cpu", "limits.memory", "limits.ephemeral-storage", "requests.storage", 'requests.nvidia.com/gpu', 'requests.cpu', 'requests.ephemeral-storage', 'requests.memory'],
          key_new: string[] = ["limitCPU", "limitMemory", "limitsRootfs", "limitsDisk", 'gpu', 'requestCPU', 'requestRootfs', 'requestMemory'];

        let quota_info: type_new;
        response.items &&
          ((response.items as unknown) as quota_type["items"]).forEach((quota) => {
            quota_info = quota.spec.quotas as type_new;
            if (quota_info) {
              key_old.forEach((key: string, index: number) => {
                quota_info[key_new[index]] = (quota_info as type_new)[key];
                delete (quota_info as type_new)[key];
              });
              const { limitCPU, limitMemory, pods, gpu } = quota_info;
              quota.metadata = Object.assign({ limitCPU, limitMemory, pods, gpu }, quota.metadata);
            }
          });
        resolve(response);
      }),
    service_components: ({ response }: post_processes_args_default) =>
      new Promise((resolve) => {
        const keys: string[] = ["kubernetes", "ensaas", "catalog", "monitoring", "logging", "db", "iothub", "servicemesh"];

        let service_components_new: type_new = response.items as type_new;
        response.items = keys.map((key) => {
          const service_component_found = service_components_new.find((service_component: any) => service_component.service.toLocaleLowerCase() === key),
            service = service_component_found.service;
          service_component_found.service =
            service.toLocaleLowerCase() !== "db"
              ? service !== "EnSaaS"
                ? `${service.charAt(0).toLocaleUpperCase()}${service.substr(1, service.length - 1).toLocaleLowerCase()}`
                : service
              : service.toLocaleUpperCase();
          return service_component_found;
        });
        resolve(response);
      }),
    monitor_tag_folder: ({ response, role }: post_processes_args_db) =>
      new Promise((resolve) => {
        let ds_list = response.filter(
          (ds) =>
            ds.type === "dash-db" && ds.folderTitle === "MonitorCenter" && level.indexOf(role) <= level.findIndex((value) => ds.tags.indexOf(value) !== -1)
        );
        let tags: string[] = [];
        let tag_list: left_menu_item[] = [];
        ds_list.forEach((db) => {
          db.tags = db.tags.filter((tag) => level.indexOf(tag) < 0);
          let tag_index = tags.findIndex((x) => x === db.tags[1]);
          if (tag_index === -1) tags.push(db.tags[1]);
          else return;
        });

        if (tags.length > 0) {
          tags.forEach((tag) => {
            tag_list.push({ key: tag });
          });
          resolve({ items: tag_list });
        } else {
          resolve(response);
        }
      }),
    monitor_dbs: ({ response, role }: post_processes_args_db) =>
      new Promise((resolve) => {
        let ds_list = response.filter(
          (ds) =>
            ds.type === "dash-db" && ds.folderTitle === "MonitorCenter" && level.indexOf(role) <= level.findIndex((value) => ds.tags.indexOf(value) !== -1)
        );
        let tags: string[] = [];
        let db_filter_by_tag: db_response[] = [];
        ds_list.forEach((db) => {
          db.tags = db.tags.filter((tag) => level.indexOf(tag) < 0);
          let tag_index = tags.findIndex((x) => x === db.tags[1]);
          if (tag_index === -1) tags.push(db.tags[1]);
        });

        if (tags.length > 0) {
          tags.forEach((tag) => {
            const sorted = ds_list
              .filter((db) => db.tags[1] === tag)
              .sort(function (x: any, y: any) {
                return x.tags[0] - y.tags[0];
              });
            db_filter_by_tag = db_filter_by_tag.concat(sorted);
          });
          resolve({ items: db_filter_by_tag });
        } else {
          resolve(response);
        }
      }),
    workspace_metric: ({ response }: post_processes_args_metric) =>
      new Promise((resolve) => {
        const units: string[] = ["Mi", "Gi", "Ti", "Pi"];
        type metric_key_type = keyof metric_values;
        let now_time = new Date(),
          name: string;
        if (response.values) {
          let all_metric: any = {};
          const a = (key: metric_key_type, unit_each?: string) => {
            let all_metric_each: any = {};
            const new_metric: any = [];
            response.values[key].forEach((value: any, index: number) => {
              let new_key = key.slice(key.indexOf("used") + 4) === "Disk" ? "PVC Disk" : key.slice(key.indexOf("used") + 4);
              let old_timestamp = now_time.getTime() - 30 * (9 - index) * 1000;
              let old_time = new Date(old_timestamp);
              let obj: any = {};
              obj["time"] = old_time.toLocaleTimeString("en-US", { hour12: false });
              obj[new_key] = {};
              new_key !== "CPU" && new_key !== "Pod" && unit_each ? (obj[new_key] = change_unit(value, unit_each, false)) : (obj[new_key] = value);
              new_metric.push(obj);
            });
            all_metric_each = new_metric.sort(function (x: any, y: any) {
              return x.time > y.time;
            });
            return all_metric_each;
          };
          (Object.keys(response.values) as Array<keyof typeof response.values>).forEach((key: metric_key_type) => {
            name = key.replace("used", "");
            name = name === "Disk" ? "PVC Disk" : name;
            if (key !== "usedCPU" && key !== "usedPod") {
              all_metric[key] = {};
              units.forEach((unit_each: string) => {
                const metric_data_each = a(key, unit_each);
                all_metric[key][unit_each] = metric_data_each;
                all_metric[key].interval = metric_data_each
                  ? Math.max.apply(
                      Math,
                      metric_data_each.map((max: any) => max[name])
                    ) -
                    Math.min.apply(
                      Math,
                      metric_data_each.map((min: any) => min[name])
                    )
                  : 0;
              });
            } else {
              const metric_data_each = a(key);
              all_metric[key] = { data: metric_data_each };
              all_metric[key].interval = metric_data_each
                ? Math.max.apply(
                    Math,
                    metric_data_each.map((max: any) => max[name])
                  ) -
                  Math.min.apply(
                    Math,
                    metric_data_each.map((min: any) => min[name])
                  )
                : 0;
            }
          });
          resolve(all_metric);
        } else resolve(response);
      }),
    cluster_metric: function (): Promise<response_type> {
      return post_processes().workspace_metric.apply(this, arguments);
    },
    namespace_metric: function (): Promise<response_type> {
      return post_processes().workspace_metric.apply(this, arguments);
    },
    workloads: ({ response }: post_processes_args_default) =>
      new Promise((resolve) => {
        ((response as unknown) as item_workload[])?.forEach((item: item_workload) => {
          item.ready_total = { ready: item.readyPod, total: item.totalPod };
          item.scale = item.totalPod;
          // item.create_time = new Date(item.createTime.replace(" +0000 UTC", "Z")).toLocaleString();
          item.create_time = item.createTime;

          delete item.createTime;
          delete item.readyPod;
          delete item.totalPod;
        });
        resolve(response);
      }),
  };

  function key_to_title(key: string): string {
    const first_letter = key.charAt(0).toLocaleUpperCase(); // 第一個字母改成大寫
    const replace_underscore = (key: string) => ` ${key.charAt(1).toLocaleUpperCase()}`; // 底線改成空格，底線後面的第一個字母也改成大寫
    const replaced_title = key
      .substr(1)
      .toLocaleLowerCase()
      .replace(/-([a-z])/g, replace_underscore)
      .trim(); // 去掉第一字母，執行取代的動作
    const title = `${first_letter}${replaced_title}`; // 合併成新的 title
    return title;
  }

  function change_unit(mi?: string | number, unit?: string, back_to_Mi?: boolean): number {
    //change unit from Mi to user selected
    if (mi && mi === "*") mi = -1;
    const units: (string | number)[] = ["Pi", 1 / 1024 / 1024 / 1024, "Ti", 1 / 1024 / 1024, "Gi", 1 / 1024, "Mi", 1, "Ki", 1024];
    const unit_found: number = units.findIndex((xx) => xx === unit);
    const transform: any = units[unit_found + 1];
    return mi ? (back_to_Mi ? Number((Number(mi) / transform).toFixed(2)) : mi === -1 ? -1 : Number((Number(mi) * transform).toFixed(2))) : 0;
  }
}
